// import logo from './logo.svg';
import { useContext, useEffect, useState } from 'react';
import { getNotificationAPI, getProfileById, getUserApi } from './apis';
import './App.css';
import MainRouter from './MainRouter/MainRouter';
import { AppContext } from './appContext';
import { useNavigate } from 'react-router-dom';
import { logoutOnJwtExpire } from './utils/helperFunctions';
import OneSignal from 'react-onesignal';
import NoInternetPage from './components/NoInternet/NoInternetPage';


function App() {
  
  console.log('API URL:', process.env.REACT_APP_ENVIRONMENT);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [loggedInUser, setLoggedInUser] = useState(null);
  const [token, setToken] = useState(localStorage.getItem('token')); // Assuming you stored the token in localStorage
  const [tokenExpiration, setTokenExpiration] = useState(null);
  const [userDetails, setUserDetails] = useState(null);
  const [chatCount, setChatCount] = useState(null);
  const [weavychatcount, setweavychatcount] = useState(null);
  const navigate = useNavigate();
  console.log('app js', userDetails);

  const logout = () => {
    localStorage.removeItem('token');
    setIsLoggedIn(false);
    setLoggedInUser(null);
    navigate('/sign-in');
    setUserDetails(null);
  };
  useEffect(() => {
    OneSignal.init({ appId: process.env.REACT_APP_ONESIGNAL_APP_ID, allowLocalhostAsSecureOrigin: true, }).then(() => {
      OneSignal.Slidedown.promptPush();
      // do other stuff
    });
  }, []);
  const clearCacheData = () => {
    caches.keys().then((names) => {
      names.forEach((name) => {
        caches.delete(name);
      });
    });
  };
  useEffect(() => {
    getnotificaitondata()
  }, [userDetails, weavychatcount, chatCount]);

  const getnotificaitondata = async () => {
    try {
      if (userDetails) {
        const resdata = await getNotificationAPI(userDetails?.DoctorProfile?._id, undefined);
        console.log(resdata?.data?.doctorNotification?.unReadNotification?.length);
        console.log(weavychatcount)
        const count = resdata?.data?.doctorNotification?.unReadNotification?.length;
        var weavychatcountF = weavychatcount ? weavychatcount : 0;
        var total = Number(weavychatcountF) + Number(count);
        setChatCount(total)
        console.log("notificatino count of the device", total)
      }

    } catch (error) {
      console.log("app js err", error)
    }

  }
  const getUserDetails = async () => {
    try {
      const res = await getProfileById(userDetails?._id);
      if (res.status === 200) {
        setUserDetails(res.data.Profile)
      }
    } catch (error) {
      console.log(error);
    }
  };
  const fetchUserProfile = async () => {
    try {
      const res = await getUserApi();
      if (res.status === 200) {
        setLoggedInUser(res.data?.Profile);
        setUserDetails(res.data?.Profile);
      }
    } catch (error) {
      if (error?.response?.data?.status === 401) {
        logoutOnJwtExpire();
        navigate('/sign-in');
      }
      else if (error?.response?.data?.error === 'User does not exist') {
        logoutOnJwtExpire();
        navigate('/sign-in');
      }
    }
  };

  useEffect(() => {
    if (Boolean(localStorage.getItem('token'))) {
      setIsLoggedIn(true);
    }

    clearCacheData();
  }, []);

  useEffect(() => {
    if (isLoggedIn) {
      fetchUserProfile();
      setToken(localStorage.getItem('token'));
    }
  }, [isLoggedIn]);

  useEffect(() => {
    if (token) {
      const tokenData = JSON.parse(atob(token.split('.')[1]));
      const tokenExpirationTime = new Date(tokenData.exp * 1000);
      setTokenExpiration(tokenExpirationTime);
      const timer = setInterval(() => {
        const currentTime = new Date();
        if (currentTime > tokenExpirationTime) {
          clearInterval(timer);
          localStorage.removeItem('token');
          setIsLoggedIn(false);
          setLoggedInUser(null);
          navigate('/sign-in');
        }
      }, 1000);
      return () => {
        clearInterval(timer);
      };
    }
  }, [token]);
const [isOnline, setIsOnline] = useState(navigator.onLine);
 useEffect(() => {
    function handleOnline() {
      setIsOnline(true);
    }
    function handleOffline() {
      setIsOnline(false);
    }
    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);
    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);
  const retryConnection = () => {
  if (navigator.onLine) {
    setIsOnline(true);
  }
};

  if (!isOnline) {
    // If offline, render NoInternet component only
    return <NoInternetPage onRetry={retryConnection} />;
  }

  return (
    // <BrowserRouter>
    <AppContext.Provider
      value={{
        state: {
          isLoggedIn,
          loggedInUser,
        },
        userDetails,
        setUserDetails,
        loggedInUser,
        setIsLoggedIn,
        fetchUserProfile,
        logout,
        getUserDetails,
        chatCount,
        setChatCount,
        weavychatcount,
        setweavychatcount,
        getnotificaitondata

      }}
    >
      <MainRouter />
    </AppContext.Provider>
    // </BrowserRouter>
  );
}

export default App;
